import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/fakeprofile',
            component: { render: () => h(RouterView) },
            children: [
                {
                    path: '/fakeprofile',
                    name: 'fakeprofile list',
                    component: () => import("./views/fakeProfileList.vue")
                },
                {
                    path: '/fakeprofile/edit/:identifier?',
                    name: 'fakeprofile edit',
                    component: () => import("./views/fakeProfileEdit.vue")
                }
            ]
        }
    ];
};